import { useMutation } from "@apollo/client";
import { useState } from "react";
import {
  RequestExportMutationMutation,
  RequestExportMutationMutationVariables,
} from "types/graphql-schema";

import Button from "@components/button/button";
import Heading from "@components/heading/heading";

import requestExportMutation from "../graphql/request-export-mutation";

const Export = () => {
  const [exportTriggered, setExportTriggered] = useState(false);
  const [requestExport] = useMutation<
    RequestExportMutationMutation,
    RequestExportMutationMutationVariables
  >(requestExportMutation);

  const handleExport = () => {
    requestExport({});
    setExportTriggered(true);
  };

  return (
    <div className="sm:w-1/2">
      <Heading small title="Export" />
      <p className="mb-4">Export all of your meeting agendas and comments:</p>
      {exportTriggered ? (
        <em>You will receive an email shortly with a link to your export</em>
      ) : (
        <Button onClick={handleExport} text="Start export" />
      )}
    </div>
  );
};

export default Export;
